import { VerificationPhotosContainer } from '@/components/custom';
import { VerificationAdditionalCheckStatusEnum } from '@/enums';
import { useUrlParams } from '../hooks';

const BodyPage = () => {

	const { gender } = useUrlParams();

	return (
		<VerificationPhotosContainer
			additionalCheckStatus={VerificationAdditionalCheckStatusEnum.WITHOUT_STATE}
			gender={gender}
			run={!!gender} />
	);

};

export default BodyPage;
